"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _styled = require("../styled");
var _excluded = ["children", "isHorizontal", "theme"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SwitchBaseGroup = function SwitchBaseGroup(props) {
  var children = props.children,
    isHorizontal = props.isHorizontal,
    theme = props.theme,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledSwitchBaseGroup, _extends({
    isHorizontal: isHorizontal
  }, rest), children));
};
SwitchBaseGroup.propTypes = {
  /**
   * Inputs to be rendered
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].node]),
  /**
   * Specifies if the group should be displayed horizontally or vertically
   */
  isHorizontal: _propTypes["default"].bool,
  /**
   * Switch base group theme
   */
  theme: _propTypes["default"].object
};
SwitchBaseGroup.defaultProps = {
  children: null,
  isHorizontal: false,
  theme: {}
};
var _default = SwitchBaseGroup;
exports["default"] = _default;